import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../commonComponents/modal/Modal';
import PlanProp from '../../../plan/propTypes/planProp';

const ConfirmationPlanModal = ({ t, plan, onClose }) => {
  const image = plan?.imageHorizontal;
  const imageURL = image && image?.thumb ? image?.thumb : '/images/no_image_upload.png';
  return (
    <Modal id="confirmation-plan-modal">
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div
            className="modal-header"
          >
            <img src={imageURL} alt={plan.name} />
          </div>
          <div className="modal-body">
            <span className="title">{t('plan.updated')}</span>
            <span className="plan-name">{plan?.name}</span>
            <button
              type="button"
              className="btn primary"
              onClick={onClose}
            >
              {t('ok')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

ConfirmationPlanModal.propTypes = {
  t: PropTypes.func.isRequired,
  plan: PropTypes.shape(PlanProp.propType).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmationPlanModal;
